import React, {useRef, useEffect, useState} from 'react';
import * as classes from './Hero.module.scss'
import { getFileName } from '../../helpers/FileCatching';
import OutputHTML from '../../helpers/OutputHTML';
import TitleContent from "./TitleContent/TitleContent";

const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Hero({content}) {

    let imageLoadCount = 0;

    let [imagesLoaded, setImagesLoaded] = useState(false)

    let imageList = useRef([]);

    let heroImageContainer = useRef([]);
    let heroHeaderContainer = useRef();
    let heroTitleContainer = useRef();
    let heroTitleMaskContainer = useRef();

    let heroImages = content.heroImages.map((item, index) => 
       
        <div key={index} className={classes.Hero__imageContainer} ref={(ref) => {if(ref) heroImageContainer.current.push(ref) }} style={{opacity:0}}>
            <img ref={(ref) => {imageList.current.push(ref)}} onLoad={imageLoaded} src={getFileName(contentImages,item.image).default} alt={item.imageAlt}/>
        </div>
    )
    
    function imageLoaded(){
        imageLoadCount++
        if(imageLoadCount == content.heroImages.length){
            setImagesLoaded(true)
            //Load lottie animation
        }
       
       
    }

    function onTitleAnimationReady(){
        //All animation loaded,  call fadeInHero()
        fadeInHero();
    }

    function fadeInHero(){
        //Begin fade in of images/lottie animation
        heroHeaderContainer.current.classList.add(classes.Hero__header_active);
        heroTitleContainer.current.classList.add(classes.Hero__title_active);
        heroTitleMaskContainer.current.classList.add(classes.Hero__title__mask_active);
        heroImageContainer.current.forEach(element => {
            element.classList.add(classes.Hero__image_active)
        });
        
    }

    function checkCachedImage(e){

        imageList.current.forEach(element => {
            if(element.complete){
                imageLoaded()
            }
        });
    }

    useEffect(() =>{
        
        checkCachedImage();

    },[])

    return (
        <div className={`${classes.Hero}`}>
            <div style={{display:"block", width:"100%", height:"100%", overflow:"hidden", position:"relative"}}>
                <div className={`${classes.Hero__topContainer}`}>
                    <div className={classes.Hero__backgroundImages}>
                        {heroImages}
                    </div>
                    <div className={`${classes.Hero__titleContainer}`}>
                        <h1 className={`${classes.Hero__header}`} ref={heroHeaderContainer} style={{opacity:0}}>{content.Title}</h1>
                        <div className={`${classes.Hero__titleContainer__wrapper}`}>
                            <div className={`${classes.Hero__title}`} ref={heroTitleContainer} style={{opacity:0}}>
                                {
                                    (
                                        imagesLoaded 
                                        ? 
                                        <TitleContent content={content.TitleLarge} onLoad={onTitleAnimationReady}/> 
                                        : 
                                        <></>
                                    )
                                }
                            </div>
                            <div className={`${classes.Hero__title__mask}`} ref={heroTitleMaskContainer}></div>
                        </div>
                    </div>
                </div>
                <div className={`${classes.Hero__introContainer}`}>
                    <p className={`${classes.Hero__intro}`}>{content.intro}</p>
                </div>
            </div>
        </div>
    );
}

export default Hero;